<template>
  <div>
    <basic-info-card :title="unitTitle" :infoList="[unitDate, unitTimeRange, unitLocation]"></basic-info-card>

    <template v-if="hasUnitData && unitData.presenter.length !== 0">
      <v-sheet class="py-3 text-center" color="primary" dark>
        Presenter
      </v-sheet>

      <v-list class="pa-0">
        <v-list-item class="pa-0" v-for="(person, i) in unitData.presenter" :key="person.id">
          <v-list-item-content :class="[i !== 0 ? 'border-top' : '', 'pa-0']">
            <person-card v-bind="person"></person-card>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>

    <template v-if="hasUnitData && (unitData.speaker != null || unitData.speaker_sponsor != null)">
      <v-sheet class="py-3 text-center" color="primary" dark>
        Speaker
      </v-sheet>

      <div class="">
        <person-card v-bind="unitData.speaker" v-if="unitData.speaker != null"></person-card>
        <sponsor-card v-bind="unitData.speaker_sponsor" v-if="unitData.speaker_sponsor != null"></sponsor-card>
      </div>
    </template>

    <template v-if="hasUnitData && unitData.attachment !== ''">
      <v-sheet class="py-3 text-center" color="primary" dark>
        Attachment
      </v-sheet>
      <div class="pa-2">
        <v-btn color="accent" @click="downloadFile(unitData.attachment)" block>
          Download
          <v-icon right dark>mdi-cloud-download</v-icon>
        </v-btn>
      </div>
    </template>

    <template v-if="hasUnitData && unitData.info !== ''">
      <v-sheet class="py-3 text-center" color="primary" dark>
        Abstract
      </v-sheet>
      <text-box-info :text="unitData.info"></text-box-info>
    </template>

    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import apiSession from "@/apis/Session";
import apiUnit from "@/apis/Unit";
import BasicInfoCard from "@/components/Card/BasicInfo";
import PersonCard from "@/components/Card/Person";
import SponsorCard from "@/components/Card/Sponsor";
import TextBoxInfo from "@/components/TextBoxInfo";

export default {
  name: "Unit",
  components: { BasicInfoCard, PersonCard, SponsorCard, TextBoxInfo },
  data() {
    return {
      sessionData: null,
      unitData: null,
      loading: true
    };
  },
  computed: {
    hasUnitData() {
      return this.unitData != null;
    },
    unitTitle() {
      if (!this.hasUnitData) return "";

      return this.unitData.title_en;
    },
    unitDate() {
      if (!this.hasUnitData) return "YYYY / MM / DD";

      return this.$dayjs(this.unitData.start_time)
        .utc()
        .format("YYYY / MM / DD");
    },
    unitTimeRange() {
      if (!this.hasUnitData) return "HH:mm ~ HH:mm";

      const { start_time, end_time } = this.unitData;
      const timeStart = this.$dayjs(start_time)
        .utc()
        .format("HH:mm");
      const timeEnd = this.$dayjs(end_time)
        .utc()
        .format("HH:mm");

      return `${timeStart} ~ ${timeEnd}`;
    },
    unitLocation() {
      if (!this.hasUnitData) return "";
      return this.$store.getters.trackName(this.unitData.session.track);
    }
  },
  methods: {
    downloadFile(link) {
      window.open(link);
    },
    async fetchData() {
      const unitId = this.$route.params.id;

      this.unitData = await apiUnit.get(unitId);

      const sessionId = this.unitData.session.id;
      this.sessionData = await apiSession.get(sessionId);
      this.loading = false;
    }
  },
  async mounted() {
    await this.fetchData();
  }
};
</script>
